import { render, staticRenderFns } from "./DateAssignment.vue?vue&type=template&id=45f2ab8e"
import script from "./DateAssignment.vue?vue&type=script&lang=js"
export * from "./DateAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports